import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const KEY = "ledesk:scroll";
const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch { return {}; } };

/** iter381 pt 11 — mémorise la position de défilement par entrée d'historique et la restaure au retour (← / navigateur), le temps que la page se charge. */
export default function ScrollMemory() {
  const loc = useLocation();
  const navType = useNavigationType();
  const prev = useRef(null);
  useEffect(() => {
    if (prev.current && prev.current !== loc.key) { const m = read(); m[prev.current] = window.scrollY; sessionStorage.setItem(KEY, JSON.stringify(m)); }
    prev.current = loc.key;
    const onScroll = () => { const m = read(); m[loc.key] = window.scrollY; sessionStorage.setItem(KEY, JSON.stringify(m)); };
    window.addEventListener("scroll", onScroll, { passive: true });
    let tries = 0, timer = null;
    if (navType === "POP") {
      const target = read()[loc.key];
      if (target > 0) {
        const tick = () => { window.scrollTo(0, target); tries += 1; if (Math.abs(window.scrollY - target) > 2 && tries < 25) timer = setTimeout(tick, 120); };
        timer = setTimeout(tick, 60);
      }
    } else window.scrollTo(0, 0);
    return () => { window.removeEventListener("scroll", onScroll); if (timer) clearTimeout(timer); };
  }, [loc.key]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
